import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { Button, Box, IconButton, Tooltip, Typography, Dialog, DialogActions, DialogContent, DialogTitle, TextField, InputAdornment, Divider } from "@mui/material";
import { Edit, Delete, ArrowBack } from "@mui/icons-material";
import apiService from "../../service/apiService";
import { CheckCircle } from "@mui/icons-material";


const ChildMarketPage = () => {
  const location = useLocation();
  const { marketLinkageMasterId, isVerified} = location.state || {};
  const navigate = useNavigate();
  const [verified, setVerified] = React.useState(isVerified || false);

  const [headerData, setHeaderData] = useState({});
  const [childData, setChildData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [verifiedBy, setVerifiedBy] = useState([]);
  const [formData, setFormData] = useState({
    basePrice: "",
    salePrice: "",
    tlSeed: "",
    consumption: "",
    sellQuantity: "",
    
  });
  const remainingQuantity =
  (parseFloat(selectedRow?.productionQuantity) || 0) - (parseFloat(formData.sellQuantity) || 0);


  const handleBack = () => {
    navigate(-1);
  };

  const fetchMarketChild = async () => {
    if (marketLinkageMasterId) {
      try {
        const response = await apiService.get(
          `/market-linkage/get-by-market-linkage-master/${marketLinkageMasterId}`
        );
        const data = response.data.body;
        setHeaderData({
          gender: data.gender,  
          caste: data.caste,
          villageName: data.villageName,
          marketLinkageMasterId: data.marketLinkageMasterId,
          farmerName: data.farmerName,
          pgCode: data.pgCode,
        });
        setChildData(data.marketLinkages || []);
        setVerifiedBy(response.data.body.verificationLogs[0] || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    fetchMarketChild();
  }, [marketLinkageMasterId]);

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setFormData({
      basePrice: row.basePrice || "",
      salePrice: row.salePrice || "",
      tlSeed: row.tlSeed || "",
      consumption: row.consumption || "",
      sellQuantity: row.sellQuantity || "",
    });
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const updateMarketLinkage = async () => {
    const payload = {
      marketLinkageId: selectedRow.marketLinkageId,
      cropProductionId: selectedRow.cropProductionId,
      basePrice: parseFloat(formData.basePrice),
      salePrice: parseFloat(formData.salePrice),
      tlSeed: parseFloat(formData.tlSeed),
      consumption: parseFloat(formData.consumption),
      sellQuantity: parseFloat(formData.sellQuantity),
    };

    try {
      const response = await apiService.put(
        "/market-linkage/update-child",
        payload
      );
      console.log("Update success:", response.data);
      setOpenDialog(false);
      fetchMarketChild(); // Refresh data after update
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const handleDeleteClick = (row) => {
    console.log("Delete row:", row);
  };




  const handleVerify = async () => {
    try {
      console.log("Verify button clicked");
  
      const response = await apiService.put('/market-linkage/verify', {
        marketLinkageMasterIds: [marketLinkageMasterId],
        remarks: "Verified successfully"
      });  
      console.log("API response:", response.data);
      alert("Verification successful!");
      setVerified(true); 
    } catch (error) {
      if (error.response) {
        console.error("API error:", error.response.data);
        alert("Verification failed: " + error.response.data.message);
      } else {
        console.error("Error occurred during verification:", error.message);
        alert("An unexpected error occurred.");
      }
    }
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "sellQuantity" && parseFloat(value) > selectedRow.productionQuantity) {
      alert("Sell Quantity cannot exceed Production Quantity.");
      return;
    }

    if (name === "tlSeed" && parseFloat(value) > remainingQuantity) {
      alert("Used TlSeed cannot exceed the remaining quantity.");
      return;
    }

    if (name === "consumption" && parseFloat(value) > remainingQuantity) {
      alert("Consumption cannot exceed the remaining quantity.");
      return;
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSellQuantityChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      if (parseFloat(value) > selectedRow.productionQuantity) {
        alert("Sell Quantity cannot exceed Production Quantity.");
        return;
      }

      setFormData({
        ...formData,
        sellQuantity: value,
        tlSeed: "",
        consumption: "",
      });
    }
  };

  const handleTlSeedChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      if (parseFloat(value) > remainingQuantity) {
        alert("Used TlSeed cannot exceed the remaining quantity.");
        return;
      }

      setFormData({
        ...formData,
        tlSeed: value,
        consumption: (remainingQuantity - parseFloat(value) || 0).toString(),
      });
    }
  };

  const handleConsumptionChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      if (parseFloat(value) > remainingQuantity) {
        alert("Consumption cannot exceed the remaining quantity.");
        return;
      }

      setFormData({
        ...formData,
        consumption: value,
        tlSeed: (remainingQuantity - parseFloat(value) || 0).toString(),
      });
    }
  };
  


  const columns = [
    { field: "seedName", headerName: "Seed Name", flex: 80 },
    { field: "className", headerName: "Seed Class", flex: 80 },
    { field: "varietyName", headerName: "Variety", flex: 80 },
    {
      field: "cultivatedArea",
      headerName: "Cultivated Area (Heater)", // Add unit in the header
      flex: 80,
      renderCell: (params) => (
        <Typography>
          {params.value} ha
        </Typography>
      ),
    },
    {
      field: "productionQuantity", headerName: "Production Quantity", flex: 100, renderCell: (params) => (
        <Typography>
          {params.value} Qtl
        </Typography>
      ),
    },
    { field: "saleType", headerName: "Sale Type", flex: 80 },
    { field: "location", headerName: "Location", flex: 80 },
    { field: "retailerName", headerName: "Retailer Name", flex: 80 },
    {
      field: "basePrice", headerName: "Base Price", flex: 80, renderCell: (params) => (
        <Typography>
          {params.value} Rs
        </Typography>
      ),
    },
    {
      field: "salePrice", headerName: "Sale Price", flex: 80, renderCell: (params) => (
        <Typography>
          {params.value} Rs
        </Typography>
      ),
    },
    {
      field: "sellQuantity", headerName: "Sell Quantity", flex: 80,
      renderCell: (params) => (
        <Typography>
          {params.value} Qtl
        </Typography>
      ),
    },
    {
      field: "tlSeed", headerName: "TL Seed", flex: 80,
      renderCell: (params) => (
        <Typography>
          {params.value || 0} Qtl
        </Typography>
      ),
    },
    {
      field: "consumption", headerName: "Consumption", flex: 80, renderCell: (params) => (
        <Typography>
          {params.value} Qtl
        </Typography>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 80,
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Tooltip title="Edit">
            <Button
              onClick={() => handleEditClick(params.row)}
              variant="contained"
              color="primary"
              size="small"
              disabled={verified} // Disable the button if verified
              sx={{ textTransform: "capitalize" }}
            >
              Edit
            </Button>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ padding: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Button
          startIcon={<ArrowBack />}
          onClick={handleBack}
          sx={{
            marginBottom: 2,
            backgroundColor: "#1976d2",
            color: "white",
            "&:hover": { backgroundColor: "#1565c0" },
          }}
        >
          Back
        </Button>
        {/* {verified ? (
          <Typography
            sx={{
              marginBottom: 2,
              fontSize: "16px",
              fontWeight: "bold",
              color: "#00796b",
            }}
          >
            ✅ Verified
          </Typography>
        ) : (
          <Button

            onClick={handleVerify}
            startIcon={<CheckCircle />}
            sx={{
              marginBottom: 2,
              backgroundColor: "#00796b",
              color: "white",
              "&:hover": { backgroundColor: "#004d40" },
            }}
          >
            Verify
          </Button>
        )} */}
      </Box>
      <Divider sx={{ marginBottom: 2 }} />
        <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
           Market Linkage Details:
        </Typography>
        <div className="d-flex">
        <div className="col-6">
        <Box>
          {/* <Typography><strong>Market Linkage Master ID:</strong> {headerData.marketLinkageMasterId}</Typography> */}
          <Typography><strong>Farmer Name:</strong> {headerData.farmerName}</Typography>
          <Typography><strong>Village Name:</strong> {headerData.villageName}</Typography>
          <Typography><strong>Gender:</strong> {headerData.gender}</Typography>
          <Typography><strong>Caste:</strong> {headerData.caste}</Typography>
          <Typography><strong>PG Code:</strong> {headerData.pgCode}</Typography>
        </Box>
        </div>
        <div className="col-6">
              <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
                Verification Details:
              </Typography>
          {verifiedBy?.verifierName && verifiedBy?.role ? (
              <Box sx={{ marginBottom: 2 }}>
              <Typography variant="body1"><strong>Last Verified By</strong></Typography>
              <Typography variant="body1"><strong>Name : </strong> {verifiedBy.verifierName || "Not Available"}</Typography>
              <Typography variant="body1"><strong>Role :</strong> {verifiedBy.role || "Not Available"}</Typography>
            </Box>
            ) : (
              <p>No verification data available</p>
            )}
        </div>
        </div>
        <Box sx={{ marginTop: 4, height: 400, width: "100%" }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>Market Linkages Item Details :</Typography>
          {childData.length > 0 ? (
            <DataGrid
              rows={childData.map((item, index) => ({ id: index, ...item }))}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5, 10, 15]}
              disableSelectionOnClick
              sx={{
                border: "1px solid #e0e0e0",
                overflowX: "auto", // Horizontal scrolling enabled
                overflowY: "auto", // Vertical scrolling enabled
                "& .MuiDataGrid-columnHeaders": { backgroundColor: "#f5f5f5" },
                "& .MuiDataGrid-cell": { fontSize: 14 },
                "& .MuiDataGrid-row:hover": { backgroundColor: "#f5f5f5" },
              }}
            />
          ) : (
            <Typography>No market linkages available.</Typography>
          )}
        </Box>

      {/* Dialog for Editing Market Linkage */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Edit Market Linkage</DialogTitle>
        <DialogContent>
        {selectedRow && (
              <Typography variant="body1">
                <strong>Production Quantity:</strong> {selectedRow.productionQuantity} kg
              </Typography>
            )}
        <TextField
            fullWidth
            margin="normal"
            label="Sell Quantity"
            name="sellQuantity"
            value={formData.sellQuantity}
            onChange={handleSellQuantityChange}
            inputProps={{
              inputMode: "decimal", 
              pattern: "^[0-9]*\\.?[0-9]*$",
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            label="base Price"
            name="basePrice"
            value={formData.basePrice}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                handleChange(e);
              }
            }}
            inputProps={{
              inputMode: "decimal", 
              pattern: "^[0-9]*\\.?[0-9]*$", 
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Sale Price"
            name="salePrice"
            value={formData.salePrice}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                handleChange(e);
              }
            }}
            inputProps={{
              inputMode: "decimal", 
              pattern: "^[0-9]*\\.?[0-9]*$", 
            }}
          />
         {remainingQuantity > 0 && (
                 <>
                   {/* Used TlSeed Field */}
                   <TextField
                     fullWidth
                     label="Used TlSeed"
                     name="tlSeed"
                     value={formData.tlSeed}
                     onChange={handleTlSeedChange}
                     variant="outlined"
                     margin="normal"
                     required
                     inputProps={{
                       inputMode: "decimal",
                       pattern: "^[0-9]*\\.?[0-9]*$",
                     }}
                   />
         
                   {/* Use for Consumption Field */}
                   <TextField
                     fullWidth
                     label="Use for Consumption"
                     name="consumption"
                     value={formData.consumption}
                     onChange={handleConsumptionChange}
                     variant="outlined"
                     margin="normal"
                     required
                     inputProps={{
                       inputMode: "decimal",
                       pattern: "^[0-9]*\\.?[0-9]*$",
                     }}
                   />
         
                   {/* <Typography variant="body2" color="textSecondary">
                     Remaining for Consumption: {remainingForConsumption > 0 ? remainingForConsumption : 0} kg
                   </Typography> */}
                 </>
               )}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">Cancel</Button>
          <Button onClick={updateMarketLinkage} color="primary">Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ChildMarketPage;
